import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { LOGO_URL } from "@/data/site";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-[#050507] min-h-screen flex flex-col" data-testid="payment-cancel-page">
      <header className="glass border-b border-white/10">
        <div className="max-w-4xl mx-auto px-5 sm:px-8 h-20 flex items-center">
          <Link to="/" className="flex items-center gap-3" data-testid="payment-cancel-logo-link">
            <img src={LOGO_URL} alt="AirDroneJet" className="h-9 w-auto" />
            <span className="font-heading font-extrabold tracking-tight">AIR<span className="fire-text">DRONE</span>JET</span>
          </Link>
        </div>
      </header>
      <main className="flex-1 flex items-center justify-center px-5">
        <motion.div
          initial={{ opacity: 0, y: 30, scale: 0.97 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="max-w-md w-full bg-[#13141B] border border-white/10 rounded-3xl p-10 text-center"
        >
          <XCircle size={52} className="text-slate-500 mx-auto mb-5" />
          <h1 className="font-heading text-2xl font-extrabold text-white">Pagamento annullato</h1>
          <p className="text-sm text-slate-400 mt-3 leading-relaxed">
            Nessun addebito è stato effettuato. La tua prenotazione resta valida: puoi pagare
            online in qualsiasi momento dalla tua Area Clienti, oppure accordare la forma di
            pagamento con noi al momento della conferma.
          </p>
          <div className="flex flex-col gap-3 mt-8">
            <Link
              to="/area-clienti"
              data-testid="payment-cancel-area-link"
              className="fire-bg text-white font-mono-adj text-xs uppercase tracking-[0.2em] font-semibold rounded-full px-8 py-4 hover:opacity-90 transition-opacity"
            >
              Vai all'Area Clienti
            </Link>
            <Link
              to="/"
              data-testid="payment-cancel-home-link"
              className="font-mono-adj text-[11px] uppercase tracking-[0.2em] text-slate-400 hover:text-orange-400 transition-colors"
            >
              Torna alla Home
            </Link>
          </div>
        </motion.div>
      </main>
    </div>
  );
}
